import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalTechnologyManipulatingModel } from './types';
import { legalTechnologyManipulatingItemValidator } from './validators/item';

const legalTechnologyManipulatingValidator: ValidateJSModel<LegalTechnologyManipulatingModel> = {
  HasManipulating: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasManipulating && attributes?.HasManipulating.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalTechnologyManipulatingItemValidator },
      };
    }
    return {};
  },
};
export default legalTechnologyManipulatingValidator;
